@if (searchable() || title()) {
  <div class="mb-4 flex items-center gap-2">
    @if (title()) {
      <h2 class="m-0 text-lg font-semibold text-default" [innerHTML]="title()"></h2>
    }
    @if (searchable()) {
      <div class="ml-auto w-60 shrink-0">
        <sb-search-input [formControl]="searchControl" />
      </div>
    }
  </div>
}

@if (displayData().length === 0) {
  <div class="rounded-lg border border-solid border-default bg-default p-12">
    <sb-empty-state
      [description]="'Try adjusting your search' | translate"
      [title]="'No results found' | translate"
      [icon]="'search-regular'"
    />
  </div>
} @else {
  <div sbScrollable>
    <table
      role="table"
      class="sb-table"
      [ngClass]="{
        'sb-table-header-sticky': stickyHeader(),
        'sb-table-footer-sticky': stickyFooter()
      }"
    >
      <thead role="rowgroup">
        <ng-template #defautHeaderRowTemplate let-columns="columns">
          <tr>
            @for (column of columns; track column.key) {
              @if (column.sortable) {
                <th sb-table-header-sort [sortKey]="column.key" [align]="column.align">
                  {{ column.header }}
                </th>
              } @else {
                <th sbTableCell [align]="column.align">{{ column.header }}</th>
              }
            }
          </tr>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="headerRowTemplate() || defautHeaderRowTemplate; context: { columns: columns() }"
        ></ng-container>
      </thead>

      <tbody role="rowgroup">
        <ng-template #defautRowTemplate let-data>
          <tr>
            @for (column of columns(); track column.key) {
              <td sbTableCell [align]="column.align">{{ data[column.key] }}</td>
            }
          </tr>
        </ng-template>

        @for (data of displayData(); track data[dataKey()]) {
          <ng-container *ngTemplateOutlet="rowTemplate() || defautRowTemplate; context: { $implicit: data }" />
        }
      </tbody>

      @if (footerRowTemplate(); as footerRowTemplate) {
        <tfoot role="rowgroup">
          <ng-container *ngTemplateOutlet="footerRowTemplate"></ng-container>
        </tfoot>
      }
    </table>
  </div>
}
